"use client";

import CommonCreate from "@/components/common/Create";
import { useState } from "react";
import TourForm from "./TourForm";
import { useGoogleMaps } from "@/context/GoogleMapsContext";

const formObj = {
  name: "",
  duration: "",
  tour_type: "",
  max_group_size: "",
  pickup_latitude: 41.3275,
  pickup_longitude: 19.8187,
  dropoff: "",
  dropoff_latitude: "",
  dropoff_longitude: "",
  currency: "",
};

const TourCreate = () => {
  const [formProp, setFormProp] = useState(formObj);

  const { isLoaded, loadError } = useGoogleMaps();

  const getLocation = (location: any) => {
    setFormProp(prev => {
      return {
        ...prev,
        dropoff: location.text,
        dropoff_latitude: location.lat,
        dropoff_longitude: location.lng
      }
    })
  }

  if (loadError) return <div>Error loading maps</div>;
  if (!isLoaded) return <div>Loading Maps...</div>;

  return (
    <CommonCreate
      title="Add new tour"
      resource="tours"
      data={formProp}
      responseMessage={`Tour ${formProp.name} added`}
    >
      <TourForm getLocation={getLocation} formProp={formProp} setFormProp={setFormProp} />
    </CommonCreate>
  );
};

export default TourCreate;
